import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "d-flex align-center justify-space-between px-4 pt-4"
};
const _hoisted_2 = {
  class: "text-caption text-grey"
};
const _hoisted_3 = {
  class: "px-4 pb-4 pt-3"
};
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center bg-slate-900/20"
};
const _hoisted_5 = {
  class: "d-inline-flex align-center gap-1 rounded-pill bg-white border border-slate-200 px-4 py-2 text-body-2 font-weight-medium text-slate-700 shadow-sm"
};
const _hoisted_6 = {
  key: 1,
  class: "w-full border border-slate-200 rounded-lg bg-slate-50 flex flex-col items-center justify-center text-center px-6 py-12 text-slate-500",
  "data-cy": "narrative-live-preview"
};
const _hoisted_7 = {
  class: "text-body-2"
};
const _hoisted_8 = {
  key: 2,
  class: "flex flex-col items-center justify-center py-24 text-slate-500"
};
import { computed, ref } from 'vue';
import { useSettlementStore } from '@/modules/matters/settlement/stores/useSettlementStore';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { VuePdfEmbed } from '@/utils/pdfHelpers';
export default {
  __name: 'SettlementLivePreviewCard',
  setup(__props) {
    const settlementStore = useSettlementStore();
    const expanded = ref(false);
    const hovered = ref(false);
    const pdfUrl = computed(() => settlementStore.statement.previewBlobUrl);
    const busy = computed(() => settlementStore.statement.previewGenerating || settlementStore.statement.previewPolling);
    const isStale = computed(() => settlementStore.narrative.isStale);
    const isTimedOut = computed(() => settlementStore.statement.previewTimedOut);
    const pdfReady = computed(() => !busy.value && !!pdfUrl.value);
    const subtitle = computed(() => {
      if (busy.value) return 'Generating preview…';
      if (isTimedOut.value) return 'Preview unavailable';
      return 'Refreshes as you edit';
    });
    const bodyIcon = computed(() => isTimedOut.value ? 'mdi-alert-circle-outline' : 'mdi-file-document-outline');
    const bodyText = computed(() => {
      if (isTimedOut.value) return 'Preview unavailable — please try again shortly';
      return 'Generating preview…';
    });
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_progress_linear = _resolveComponent("v-progress-linear");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_card, {
        class: "rounded-xl border border-slate-200",
        elevation: "0"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "text-base font-weight-bold text-slate-800"
        }, "Live preview", -1)), _createElementVNode("div", _hoisted_2, _toDisplayString(subtitle.value), 1)]), _createVNode(LlSecondaryButton, {
          size: "small",
          variant: "outlined",
          "prepend-icon": "mdi-arrow-expand",
          "data-cy": "narrative-expand-preview",
          onClick: _cache[0] || (_cache[0] = $event => expanded.value = true)
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Expand ", -1)]))]),
          _: 1
        })]), _createElementVNode("div", _hoisted_3, [pdfReady.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "relative w-full border border-slate-200 rounded-lg overflow-hidden bg-white cursor-pointer focus:outline focus:outline-2 focus:outline-blue-400",
          role: "button",
          tabindex: "0",
          "aria-label": "Expand statement preview",
          "data-cy": "narrative-live-preview",
          onClick: _cache[1] || (_cache[1] = $event => expanded.value = true),
          onKeydown: [_cache[2] || (_cache[2] = _withKeys(_withModifiers($event => expanded.value = true, ["prevent"]), ["enter"])), _cache[3] || (_cache[3] = _withKeys(_withModifiers($event => expanded.value = true, ["prevent"]), ["space"]))],
          onMouseenter: _cache[4] || (_cache[4] = $event => hovered.value = true),
          onMouseleave: _cache[5] || (_cache[5] = $event => hovered.value = false),
          onFocus: _cache[6] || (_cache[6] = $event => hovered.value = true),
          onBlur: _cache[7] || (_cache[7] = $event => hovered.value = false)
        }, [_createElementVNode("div", {
          class: _normalizeClass(["max-h-[320px] overflow-hidden transition-opacity", {
            'opacity-40': isStale.value
          }])
        }, [_createVNode(_unref(VuePdfEmbed), {
          source: pdfUrl.value,
          page: 1
        }, null, 8, ["source"])], 2), isStale.value || hovered.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createVNode(_component_v_icon, {
          size: "16"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(isStale.value ? 'mdi-refresh' : 'mdi-arrow-expand'), 1)]),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(isStale.value ? 'Updating…' : 'Click to expand'), 1)])])) : _createCommentVNode("", true)], 32)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [busy.value ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          size: "28",
          width: "3",
          class: "mb-3"
        })) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_v_icon, {
          size: "32",
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(bodyIcon.value), 1)]),
          _: 1
        }), _createElementVNode("div", _hoisted_7, _toDisplayString(bodyText.value), 1)], 64))]))]), _createVNode(_component_v_dialog, {
          modelValue: expanded.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => expanded.value = $event),
          "max-width": "900",
          scrollable: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card, null, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, {
              class: "d-flex align-center justify-space-between py-3"
            }, {
              default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("span", {
                class: "text-h6 font-weight-bold"
              }, "Live preview", -1)), _createVNode(LlSecondaryButton, {
                icon: "mdi-close",
                variant: "text",
                size: "small",
                "aria-label": "Close preview",
                "data-cy": "narrative-preview-close",
                onClick: _cache[8] || (_cache[8] = $event => expanded.value = false)
              })]),
              _: 1
            }), _createVNode(_component_v_card_text, {
              class: "pa-0 bg-[#f1f5f9] min-h-[360px]"
            }, {
              default: _withCtx(() => [busy.value ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: "",
                color: "success"
              })) : _createCommentVNode("", true), pdfUrl.value ? (_openBlock(), _createBlock(_unref(VuePdfEmbed), {
                key: 1,
                source: pdfUrl.value
              }, null, 8, ["source"])) : !busy.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_v_icon, {
                size: "36",
                class: "mb-2"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(bodyIcon.value), 1)]),
                _: 1
              }), _createTextVNode(" " + _toDisplayString(bodyText.value), 1)])) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
};